module.exports = __webpack_public_path__ + "img/rolling.06a6135.svg";